import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { Material } from 'src/app/interfaces/material';

@Injectable({
  providedIn: 'root'
})
export class MaterialsProviderService extends APIProviderService<Material> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Materials`;
  }
}
